<template>
  <el-form ref="form" :model="form" label-width="140px" class="elForm">
    <el-form-item label="优惠券名称：">
      <el-input v-model="form.input" placeholder="" style="width: 400px;"></el-input>
      <span style="color: gray; margin-left: 10px;">名称不会超过15个字，中文</span>
    </el-form-item>
    <el-form-item label="优惠券图片：">
       <el-image 
    style="width: 100px; height: 100px"
    :src="url" 
    :preview-src-list="srcList">
  </el-image>
      <div style="margin-top: 15px">
        消费满
        <el-input placeholder="请输入内容" v-model="input2" style="width: 170px;">
          <template slot="append">元</template>
        </el-input>
        减
        <el-input placeholder="请输入内容" v-model="input2" style="width: 170px;">
          <template slot="append">元</template>
        </el-input>
      </div>
    </el-form-item>
    <el-form-item label="兑换消耗积分分数：">
        <el-input placeholder="请输入内容" v-model="input2" style="width: 400px;">
          <template slot="append">积分</template>
        </el-input>
    </el-form-item>
    <el-form-item label="领券时间：">
      <el-date-picker size="small" style="width: 400px;" v-model="form.create_time" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
    </el-form-item>
    <el-form-item label="优惠券有效期：">
      <el-radio-group v-model="form.radio" style="margin-left: 0">
        <el-radio label="固定时间"></el-radio>
        <el-radio label="领取N天内"></el-radio>
      </el-radio-group>
      <br />
      <el-date-picker size="small"  style="width: 400px;" v-model="form.create_time" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
    </el-form-item>
    <el-form-item label="状态：">
      <el-radio-group v-model="form.radio" style="margin-left: 0">
        <el-radio label="正常"></el-radio>
        <el-radio label="停用"></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item class="centerBtn">
      <el-button type="primary" @click="onSubmit">添加</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        // 图片
        url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        srcList: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
        ]
      },
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
  },
};
</script>

<style lang="less" scoped>
.elForm {
  background-color: #fff;
  padding: 30px;
}

.centerBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
